import React, { useMemo, useState } from "react";

import {
  Layout,
  Menu,
  Avatar,
  Drawer,
  Badge,
  Switch,
  Grid,
  Typography,
  Button,
  Card,
} from "antd";
import { motion, AnimatePresence } from "framer-motion";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  UserOutlined,
  DashboardOutlined,
  DollarOutlined,
  BarChartOutlined,
  TeamOutlined,
  SettingOutlined,
  AppstoreOutlined,
  ShopOutlined,
  SafetyOutlined,
  LogoutOutlined,
  ShoppingCartOutlined,
  CloseOutlined, TruckOutlined,
} from "@ant-design/icons";

import {
ReceiptLongOutlined,
} from "@mui/icons-material";

import logo from "./Logo/zulu.png";

import YearSelector from "../../api/context/YearSelector";
import DailySales from "./Product/DailySales/DailySales";
import Cards from "./Storeowner/Cards";
import UserManagement from "./Register/UserManagement";
import ProfitAnalytics from "./Product/Profit/ProfitAnalytics";
import ProductList from "./Product/ProductList";
import UserProfile from "./Profile/UserProfile";
import Logout from "./Profile/Logout";
import CarPurchaseAgreement from "./Product/Carpurchase/CarPurchaseAgreement";
import CarAgreementReceipt from "./Product/Carpurchase/CarAgreementReceipt";
import Product from "./Product/Product";
import ShippingTrip from "./CreateShipment/ShippingTrip";
import ShippingTripList from "./CreateShipment/ShippingTripList";
import CreateShipment from "./CreateShipment/CreateShipment";
import PrepaidCard from "./PrepaidCard/PrepaidCard";
import GoodsItemList from "./CreateShipment/GoodsItemList";


const { Header, Sider, Content } = Layout;
const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const StoreOwnerDashboard = () => {
  const screens = useBreakpoint();

  const [collapsed, setCollapsed] = useState(false);

  const [drawerVisible, setDrawerVisible] =
    useState(false);
  
  const [productPopup, setProductPopup] =
        useState(false);

  const [darkMode, setDarkMode] =
    useState(false);

  const [activeComponent, setActiveComponent] =
    useState("dashboard");

  // =========================================
  // THEME
  // =========================================
  const theme = useMemo(() => {
    return {
      primary: "#0B6E4F",

      background: darkMode
        ? "#07130F"
        : "#F3F7F5",

      sider: darkMode
        ? "#0E1C17"
        : "#ffffff",

      header: darkMode
        ? "rgba(14,28,23,0.92)"
        : "rgba(255,255,255,0.92)",

      card: darkMode
        ? "#12231D"
        : "#ffffff",

      border: darkMode
        ? "#1F3A31"
        : "#E6ECE9",

      text: darkMode
        ? "#F9FAFB"
        : "#111827",

      textSecondary: darkMode
        ? "#9CA3AF"
        : "#6B7280",

      hover: darkMode
        ? "rgba(11,110,79,0.18)"
        : "rgba(11,110,79,0.08)",
    };
  }, [darkMode]);

  // =========================================
  // MENU ITEMS
  // =========================================
  const menuItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label: "Overview",
    },

    {
      key: "addproducts",
      icon: <AppstoreOutlined />,
      label: "Add Products",
    },

    {
      key: "profitanalytics",
      icon: <BarChartOutlined />,
      label: "Profit Analytics",
    },

    {
      key: "profit",
      icon: <DollarOutlined />,
      label: "Revenue",
    },

    {
      key: "dailysales",
      icon: <ShopOutlined />,
      label: "Daily Sales",
    },

    {
      key: "products",
      icon: <AppstoreOutlined />,
      label: "View Products",
    },

    {
      key: "carpurchaseagreement",
      icon: <ShoppingCartOutlined />,
      label: "Car Purchase Agreement",
    },

    {
      key: "purchasereciept",
      icon: <ReceiptLongOutlined />,
      label: "Car Reciept",
    },

    {
      key: "shippingtrip",
      icon: <TruckOutlined />,
      label: "Assign Trip",
    },

    {
      key: "createshipment",
      icon: <TruckOutlined />,
      label: "Goods Shiping",
    },

      {
          key: "goodsitemlist",
          icon: <TruckOutlined />,
          label: "Goods Listing",
        },

    {
      key: "shipingtriplist",
      icon: <TruckOutlined />,
      label: "Trip Status",
    },

    {
          key: "prepaidcard",
          icon: <SettingOutlined />,
          label: "Card Payment",
        },

    {
      key: "staff",
      icon: <TeamOutlined />,
      label: "Users Management",
    },

    {
      key: "risk",
      icon: <SafetyOutlined />,
      label: "Security",
    },


  ];

  // =========================================
  // SIDEBAR CONTENT
  // =========================================
  const sidebarContent = (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: theme.sider,
      }}
    >
      {/* ========================================= */}
      {/* TOP BRAND */}
      {/* ========================================= */}
      <div
        style={{
          padding:
            collapsed && screens.md
              ? "20px 10px"
              : "20px",

          borderBottom: `1px solid ${theme.border}`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{
              width: 42,
              height: 42,
              objectFit: "contain",
              borderRadius: 12,
            }}
          />

          {(!collapsed || !screens.md) && (
            <div style={{ overflow: "hidden" }}>
              <Title
                level={5}
                style={{
                  color: theme.text,
                  margin: 0,
                  lineHeight: 1.1,
                }}
              >
                Zulu Finance
              </Title>

              <Text
                style={{
                  color:
                    theme.textSecondary,

                  fontSize: 12,
                }}
              >
                Store Management
              </Text>
            </div>
          )}
        </div>
      </div>

      {/* ========================================= */}
      {/* USER CARD */}
      {/* ========================================= */}
      <div
        style={{
          padding:
            collapsed && screens.md
              ? 10
              : 18,
        }}
      >
 
          <div
  style={{
    padding: collapsed && screens.md ? 10 : 18,
  }}
>
<UserProfile
  darkMode={darkMode}
  collapsed={collapsed}
  screens={screens}
/>
</div>
      </div>

      {/* ========================================= */}
      {/* MENU */}
      {/* ========================================= */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "0 12px",
        }}
      >
        {/* <Menu
          mode="inline"
          selectedKeys={[activeComponent]}
          theme={darkMode ? "dark" : "light"}
          inlineCollapsed={
            collapsed && screens.md
          }
          items={menuItems}
          onClick={(e) => {
            setActiveComponent(e.key);

            if (!screens.md) {
              setDrawerVisible(false);
            }
          }}
          style={{
            background: "transparent",
            border: "none",
            color: theme.text,
          }}
          className="modern-bank-menu"
        /> */}
                <Menu
                  mode="inline"
                  theme={darkMode ? "dark" : "light"}
                  selectedKeys={[activeComponent]}
                  inlineCollapsed={
                    collapsed && screens.md
                  }
                  items={menuItems}
                  onClick={({ key }) => {
                    if (key === "addproducts") {
                      setProductPopup(true);
                    } else {
                      setActiveComponent(key);
                    }
        
                    if (!screens.md) {
                      setDrawerVisible(false);
                    }
                  }}
                  className="modern-admin-menu"
                  style={{
                    background: "transparent",
                    border: "none",
                  }}
                />

        {/* ========================================= */}
        {/* MOBILE YEAR SELECTOR */}
        {/* ========================================= */}
        {!screens.md && (
          <div
            style={{
              padding:
                "6px 2px 18px 2px",
            }}
          >
            <div
              style={{
                background: darkMode
                  ? "rgba(255,255,255,0.04)"
                  : "#ffffff",

                border: `1px solid ${theme.border}`,

                borderRadius: 18,

                padding: 16,
              }}
            >
              <div
                style={{
                  color: theme.text,

                  fontWeight: 600,

                  fontSize: 14,

                  marginBottom: 12,
                }}
              >
                Financial Year
              </div>

             <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
  <YearSelector />
</div>
            </div>
          </div>
        )}
      </div>

      {/* ========================================= */}
      {/* BOTTOM */}
      {/* ========================================= */}
      {/* <div
        style={{
          padding: 16,

          borderTop: `1px solid ${theme.border}`,
        }}
      >
        <Button
          danger
          icon={<LogoutOutlined />}
          block
          size="large"
          style={{
            borderRadius: 14,
            height: 48,
          }}
        >
          {(!collapsed || !screens.md) &&
            "Logout"}
        </Button>
      </div> */}
      <div
  style={{
    padding: 16,
    borderTop: `1px solid ${theme.border}`,
  }}
>
  <Logout
    darkMode={darkMode}
    collapsed={collapsed}
    screens={screens}
    theme={theme}
  />
</div>
    </div>
  );

  // =========================================
  // RENDER CONTENT
  // =========================================
  const renderContent = () => {
    switch (activeComponent) {
      case "dashboard":
        return <Cards />;

      case "profitanalytics":
        return (
          <Card
            style={{
              borderRadius: 24,
              background: theme.card,
              border: `1px solid ${theme.border}`,
            }}
          >
            <ProfitAnalytics />
          </Card>
        );

      case "profit":
        return (
          <Card
            style={{
              borderRadius: 24,
              background: theme.card,
              border: `1px solid ${theme.border}`,
            }}
          >
            <Title
              level={3}
              style={{
                color: theme.text,
              }}
            >
              Revenue Dashboard
            </Title>

            <Text
              style={{
                color:
                  theme.textSecondary,
              }}
            >
              Track profits,
              expenses, and cash
              flow.
            </Text>
          </Card>
        );

      case "dailysales":
        return <DailySales />; 

      case "createshipment":   
        return <CreateShipment />;

      case "goodsitemlist":   
        return <GoodsItemList />;

      case "shippingtrip":   
        return <ShippingTrip />; 

      case "shipingtriplist":
        return <ShippingTripList />;

      case "prepaidcard":
        return <PrepaidCard />;

      case "carpurchaseagreement":
        return <CarPurchaseAgreement />; 

      case "purchasereciept":
        return <CarAgreementReceipt />;

      case "staff":
        return <UserManagement />;

      case "risk":
        return (
          <Card
            style={{
              borderRadius: 24,
              background: theme.card,
              border: `1px solid ${theme.border}`,
            }}
          >
            <Title
              level={3}
              style={{
                color: theme.text,
              }}
            >
              Security Monitoring
            </Title>

            <Text
              style={{
                color:
                  theme.textSecondary,
              }}
            >
              Review suspicious
              activities and alerts.
            </Text>
          </Card>
        );

      case "products":
        return (
          <Card
            style={{
              borderRadius: 24,
              background: theme.card,
              border: `1px solid ${theme.border}`,
            }}
          >
           <ProductList / >
          </Card>
        );

      default:
        return <Cards />;
    }
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        background:
          theme.background,
      }}
    >
      {/* ========================================= */}
      {/* DESKTOP SIDEBAR */}
      {/* ========================================= */}
      {screens.md && (
        <Sider
          collapsed={collapsed}
          trigger={null}
          collapsedWidth={90}
          width={290}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,

            overflow: "hidden",

            background:
              theme.sider,

            borderRight: `1px solid ${theme.border}`,

            zIndex: 1001,
          }}
        >
          {sidebarContent}
        </Sider>
      )}

      {/* ========================================= */}
      {/* MOBILE DRAWER */}
      {/* ========================================= */}
      {!screens.md && (
        <Drawer
          placement="left"
          open={drawerVisible}
          onClose={() =>
            setDrawerVisible(false)
          }
          width={290}
          closable={false}
          bodyStyle={{
            padding: 0,
            background:
              theme.sider,
          }}
        >
          {sidebarContent}
        </Drawer>
      )}

      {/* ========================================= */}
      {/* MAIN */}
      {/* ========================================= */}
      <Layout
        style={{
          marginLeft: screens.md
            ? collapsed
              ? 90
              : 290
            : 0,

          transition:
            "all 0.3s ease",

          background:
            "transparent",
        }}
      >
        {/* ========================================= */}
        {/* HEADER */}
        {/* ========================================= */}
        <Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 999,

            height: screens.xs
              ? 76
              : 82,

            padding: screens.xs
              ? "0 12px"
              : "0 22px",

            background:
              theme.header,

            backdropFilter:
              "blur(16px)",

            borderBottom: `1px solid ${theme.border}`,

            display: "flex",
            alignItems: "center",
            justifyContent:
              "space-between",

            gap: screens.xs
              ? 10
              : 18,
          }}
        >
          {/* ========================================= */}
          {/* LEFT SIDE */}
          {/* ========================================= */}
          <div
            style={{
              display: "flex",
              alignItems: "center",

              gap: screens.xs
                ? 10
                : 16,

              flex: 1,

              minWidth: 0,
            }}
          >
            {/* MENU BUTTON */}
            <Button
              type="text"
              icon={
                screens.md ? (
                  collapsed ? (
                    <MenuUnfoldOutlined />
                  ) : (
                    <MenuFoldOutlined />
                  )
                ) : (
                  <MenuUnfoldOutlined />
                )
              }
              onClick={() => {
                if (screens.md) {
                  setCollapsed(
                    !collapsed
                  );
                } else {
                  setDrawerVisible(
                    true
                  );
                }
              }}
              style={{
                width: 46,
                height: 46,

                borderRadius: 14,

                flexShrink: 0,

                color:
                  theme.text,

                background:
                  darkMode
                    ? "rgba(255,255,255,0.05)"
                    : "#ffffff",

                border: `1px solid ${theme.border}`,

                display: "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
              }}
            />

            {/* LOGO */}
            <div
              style={{
                width:
                  screens.xs
                    ? 38
                    : 42,

                height:
                  screens.xs
                    ? 38
                    : 42,

                borderRadius: 12,

                overflow:
                  "hidden",

                flexShrink: 0,

                display: "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",

                background:
                  darkMode
                    ? "rgba(255,255,255,0.04)"
                    : "#ffffff",

                border: `1px solid ${theme.border}`,
              }}
            >
              <img
                src={logo}
                alt="logo"
                style={{
                  width: "75%",
                  height: "75%",
                  objectFit:
                    "contain",
                }}
              />
            </div>

            {/* TITLE */}
            <div
              style={{
                display: "flex",
                flexDirection:
                  "column",

                justifyContent:
                  "center",

                minWidth: 0,

                overflow:
                  "hidden",

                lineHeight: 1.1,
              }}
            >
              <div
                style={{
                  color:
                    theme.text,

                  fontWeight: 700,

                  fontSize:
                    screens.xs
                      ? 15
                      : 20,

                  whiteSpace:
                    "nowrap",

                  overflow:
                    "hidden",

                  textOverflow:
                    "ellipsis",

                  letterSpacing:
                    0.2,
                }}
              >
                Zulu Store
                Dashboard
              </div>

              {!screens.xs && (
                <div
                  style={{
                    color:
                      theme.textSecondary,

                    fontSize: 12,

                    marginTop: 4,

                    fontWeight: 500,

                    whiteSpace:
                      "nowrap",

                    overflow:
                      "hidden",

                    textOverflow:
                      "ellipsis",
                  }}
                >
                  Secure Financial
                  Management
                  System
                </div>
              )}
            </div>
          </div>

          {/* ========================================= */}
          {/* CENTER */}
          {/* ========================================= */}
          {screens.lg && (
            <div
              style={{
                width: 230,

                flexShrink: 0,
              }}
            >
            <div style={{ marginTop: "23px" }}>
  <YearSelector />
</div>
            </div>
          )}

          {/* ========================================= */}
          {/* RIGHT */}
          {/* ========================================= */}
          <div
            style={{
              display: "flex",
              alignItems: "center",

              gap: screens.xs
                ? 8
                : 14,

              flexShrink: 0,
            }}
          >
            {/* DARK MODE */}
            <div
              style={{
                padding:
                  "8px 12px",

                borderRadius: 14,

                display: "flex",

                alignItems:
                  "center",

                justifyContent:
                  "center",

                background:
                  darkMode
                    ? "rgba(255,255,255,0.05)"
                    : "#ffffff",

                border: `1px solid ${theme.border}`,
              }}
            >
              <Switch
                checked={darkMode}
                onChange={() =>
                  setDarkMode(
                    !darkMode
                  )
                }
                checkedChildren="🌙"
                unCheckedChildren="☀️"
              />
            </div>

            {/* NOTIFICATION */}
            <Badge count={5}>
              <Button
                type="text"
                icon={
                  <BellOutlined />
                }
                style={{
                  width: 46,
                  height: 46,

                  borderRadius: 14,

                  color:
                    theme.text,

                  background:
                    darkMode
                      ? "rgba(255,255,255,0.05)"
                      : "#ffffff",

                  border: `1px solid ${theme.border}`,

                  display: "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "center",
                }}
              />
            </Badge>

            {/* USER */}
            <Avatar
              size={44}
              icon={<UserOutlined />}
              style={{
                background:
                  theme.primary,

                flexShrink: 0,

                cursor:
                  "pointer",
              }}
            />
          </div>
        </Header>

        {/* ========================================= */}
        {/* CONTENT */}
        {/* ========================================= */}
        <Content
          style={{
            padding:
              screens.xs
                ? 14
                : 24,
          }}
        >
          {renderContent()}
        </Content>
      </Layout>

       {/* ========================================= */}
      {/* PRODUCT POPUP */}
      {/* ========================================= */}
      <AnimatePresence>
        {productPopup && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              inset: 0,

              background:
                "rgba(0,0,0,0.55)",

              backdropFilter:
                "blur(6px)",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",

              padding: 20,

              zIndex: 2000,
            }}
          >
            <motion.div
              initial={{
                scale: 0.8,
                opacity: 0,
                y: 40,
              }}
              animate={{
                scale: 1,
                opacity: 1,
                y: 0,
              }}
              exit={{
                scale: 0.8,
                opacity: 0,
              }}
              transition={{
                duration: 0.3,
              }}
              style={{
                width: "100%",
                maxWidth: 1200,

                maxHeight: "92vh",

                overflowY: "auto",

                background:
                  theme.card,

                borderRadius: 28,

                position: "relative",

                padding: screens.xs
                  ? 14
                  : 24,

                border: `1px solid ${theme.border}`,
              }}
            >
              {/* CLOSE BTN */}
              <Button
                shape="circle"
                icon={<CloseOutlined />}
                onClick={() =>
                  setProductPopup(
                    false
                  )
                }
                style={{
                  position: "absolute",
                  top: 18,
                  right: 18,

                  width: 42,
                  height: 42,

                  zIndex: 20,
                }}
              />

              <Product />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>


      {/* ========================================= */}
      {/* CUSTOM CSS */}
      {/* ========================================= */}
      <style>{`
        .modern-bank-menu .ant-menu-item {
          height: 52px !important;
          line-height: 52px !important;
          border-radius: 14px !important;
          margin: 8px 0 !important;
          font-size: 15px !important;
          font-weight: 500 !important;
        }

        .modern-bank-menu .ant-menu-item .anticon {
          font-size: 18px !important;
        }

        .modern-bank-menu .ant-menu-item-selected {
          background: linear-gradient(
            135deg,
            #0B6E4F,
            #15803D
          ) !important;

          color: #ffffff !important;

          font-weight: 700 !important;
        }

        .modern-bank-menu .ant-menu-item-selected::after {
          display: none !important;
        }

        .modern-bank-menu .ant-menu-item:hover {
          background: rgba(
            11,
            110,
            79,
            0.12
          ) !important;
        }

        .ant-layout-sider-trigger {
          display: none !important;
        }

        .ant-drawer-content {
          background: ${theme.sider} !important;
        }

        .ant-menu-dark,
        .ant-menu-light {
          background: transparent !important;
        }

        @media (max-width: 768px) {
          .modern-bank-menu .ant-menu-item {
            height: 50px !important;
            line-height: 50px !important;
            font-size: 15px !important;
          }
        }

        @media (max-width: 480px) {
          .modern-bank-menu .ant-menu-item {
            font-size: 14px !important;
          }
        }
      `}</style>
    </Layout>
  );
};

export default StoreOwnerDashboard;

